import { initCategoriesSlider } from './sliders/slider-category';
import { initBrandSlider } from './sliders/slider-brands';

initBrandSlider('.ddr-brand-slider > *');
initCategoriesSlider('.ddr-category-slider > *');
